(function () {
  'use strict';

  angular.module('app').component('exchangeRatesPage', ExchangeRatesPageComponent());

  function ExchangeRatesPageComponent() {
    return {
      bindings: {},
      templateUrl: './app/ajs/exchange-rates/exchange-rates-page.component.html',
      controller: function () {},
      controllerAs: 'vm',
    };
  }
})();
